export const LOAD_HOUSE_TERMS_FAILURE = 'LOAD_HOUSE_TERMS_FAILURE';
export const LOAD_HOUSE_TERMS_REQUEST = 'LOAD_HOUSE_TERMS_REQUEST';
export const LOAD_HOUSE_TERMS_SUCCESS = 'LOAD_HOUSE_TERMS_SUCCESS';
